import cn from "classnames";

import { ISwitchProps } from "./types";
import { useStyles } from "./styles";
import { MuiSwitch } from "./MuiSwitch";
import React from "react";

export const Switch = ({
    value,
    onChange,
    leftLabel,
    rightLabel,
}: ISwitchProps) => {
    const styles = useStyles();

    const handleChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
    }, [onChange]);

    return (
        <div className={styles.wrapper}>
            {leftLabel && (
                <span
                    className={cn(styles.label, styles.leftLabel, {
                        [styles.labelActive]: !value,
                    })}
                >
                    {leftLabel}
                </span>
            )}
            <MuiSwitch
                className={styles.switchRoot}
                checked={value}
                onChange={handleChange}
            />
            {rightLabel && (
                <span
                    className={cn(styles.label, styles.rightLabel, {
                        [styles.labelActive]: value,
                    })}
                >
                    {rightLabel}
                </span>
            )}
        </div>
    );
};